import {Outlet} from "react-router-dom";

export default function UsersRootLayout() {

    return (
        <>
            <Outlet/>
        </>
    );
}